<a class="skip-navigation"
   href="#main-content"
   (click)="skipToMainContent($event)">Skip to main content</a>

<!-- Main view/routes wrapper-->
<router-outlet></router-outlet>
